import state from './state'
import mutation from './mutation'
import action from './action'
import getter from './getter'

export default {
  state,
  mutation,
  action,
  getter
}
